import { Heading, List, ListItem } from '@wrisk/ui-components'
import React from 'react'

import { Chat } from '../Chat'
import { ContextualHelpLink, ExternalLink } from '../links'
import { SignIn } from '../SignIn'

export default {
  ExternalLink: <ExternalLink />,
  BusinessTerms: <ExternalLink type='business-terms' />,
  CookiePolicy: <ExternalLink type='cookie-policy' />,
  PrivacyPolicy: <ExternalLink type='privacy-policy' />,
  ContextualHelp: <ContextualHelpLink />,
  Chat: <Chat />,
  Heading: <Heading />,
  SignIn: <SignIn />,

  ul: <List gap={[2, 3]} />,
  li: <ListItem variant='bullet' />,
  abbr: <abbr />,
}
